import { makeObservable, observable } from "mobx";
import { ErrorMessages } from "./errorMessage";
import Validator, { ValidatedValue, ValidatorModel } from "./validator";
import Formatter, { CapitalizationType } from "./formatter";

export interface AnimalProposalModel {
  name: ValidatedValue<string>;
  race: ValidatedValue<string>;
  age: ValidatedValue<number>;
}

interface DefaultAnimalArguments {
  name?: string;
  race?: string;
  age?: number;
}

const animalValidators: ValidatorModel = {
  age: [
    { name: "ageIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "ageIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ],
  name: [
    { name: "nameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "nameIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required },
    { name: "nameIsIncorrect", fn: Validator.personalName, errorMessage: ErrorMessages.client.firstName }
  ],
  race: [
    { name: "raceIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
    { name: "raceIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
  ]
};

export class AnimalProposal implements AnimalProposalModel {
  @observable name: ValidatedValue<string> = new ValidatedValue("", animalValidators.name);
  @observable race: ValidatedValue<string> = new ValidatedValue("", animalValidators.race);
  @observable age: ValidatedValue<number> = new ValidatedValue(0, animalValidators.age);

  constructor(args?: DefaultAnimalArguments) {
    makeObservable(this);

    this.name.value = Formatter.capitalizeWords(args?.name?.trim(), CapitalizationType.full) ?? "";
    this.race.value = Formatter.capitalizeWords(args?.race?.trim(), CapitalizationType.full) ?? "";
    this.age.value = args?.age ?? 0;
  }
}
